import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconStar = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24.5 24.5",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		children: [/* @__PURE__ */ _jsx("circle", {
			cx: 12.25,
			cy: 12.25,
			r: 11.5
		}), /* @__PURE__ */ _jsx("path", { d: "m13.023 6.245 1.658 3.582h3.234a.793.793 0 0 1 .566 1.384l-2.8 2.762 1.555 3.572a.848.848 0 0 1-1.206 1.059l-3.759-2.115-3.769 2.116a.847.847 0 0 1-1.206-1.059l1.555-3.571-2.8-2.762a.791.791 0 0 1 .55-1.386h3.234l1.66-3.582a.862.862 0 0 1 1.528 0Z" })]
	})
});
export { SvgIconStar as ReactComponent };
